/*
 * 文件EN: index.vue,
 * 文件CN: 项目列表,
 * 创建时间: Monday, 15th June 2020 6:04:33 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */

<template>
  <div ref="indexPage" class="project-list">
    <!--搜索栏-->
    <common-query :queury="query" @query="onClickQuery">
      <el-form-item label="提供公司">
        <el-input v-model="query.provideCompany"></el-input>
      </el-form-item>
      <el-form-item label="权限使用">
        <common-select v-model="query.usePerm" :list="usePermList" />
      </el-form-item>
      <el-form-item label="状态">
        <common-select v-model="query.state" :list="stateList" />
      </el-form-item>
      <el-form-item label="生成日期" class="auto-width">
        <date-picker v-model="query.SCreateTime"></date-picker>
        <span class="middle-text">至</span>
        <date-picker v-model="query.ECreateTime"></date-picker>
      </el-form-item>
      <el-form-item label="有效期" class="auto-width">
        <date-picker v-model="query.SValidTime"></date-picker>
        <span class="middle-text">至</span>
        <date-picker v-model="query.EValidTime"></date-picker>
      </el-form-item>
      <el-form-item label="剩余次数" class="all-width">
        <el-input v-model="query.minRemanentCount"></el-input>
        <span class="middle-text">至</span>
        <el-input v-model="query.maxRemanentCount"></el-input>
      </el-form-item>
    </common-query>

    <div class="table-list" v-loading="showLoading">
      <!-- 表格 -->
      <div class="table-content">
        <el-table
          :data="listData"
          header-cell-class-name="dark"
          :height="tableHeight"
          fit
          stripe
          border
        >
          <table-column type="index" label="序号"></table-column>
          <table-column prop="apiCode" label="API号" width="270px" align="center"></table-column>
          <table-column prop="createTime" label="生成日期" width="150px" align="center"></table-column>
          <table-column prop="validTime" label="有效期" width="100px" align="center"></table-column>
          <table-column prop="apiDescribe" label="api描述" width="700px" align="center"></table-column>
          <table-column prop="provideCompany" label="提供公司" width="80px" align="center"></table-column>
          <table-column prop="totalCount" label="累计使用次数" width="80px" align="center"></table-column>
          <table-column prop="remanentCount" label="剩余查询次数" width="80px" align="center"></table-column>
          <table-column label="类别" width="80px" align="center">
            <template slot-scope="{ row:{ invokeType } }">
              <span>{{selects.getLabel(invokeTypeList,invokeType)}}</span>
            </template>
          </table-column>
          <table-column label="权限使用" width="60px" align="center">
            <template slot-scope="{ row:{ usePerm } }">
              <span>{{selects.getLabel(usePermList,usePerm)}}</span>
            </template>
          </table-column>
          <table-column label="状态" width="60px" align="center">
            <template slot-scope="{ row:{ state } }">
              <span>{{selects.getLabel(stateList,state)}}</span>
            </template>
          </table-column>
          <el-table-column width="80">
            <div slot="header" class="fixed-right-column">操作</div>
            <template slot-scope="{ row }">
              <el-button
                @click="handleCheck(row,'appList/details/check')"
                type="text"
                size="small"
              >查看</el-button>
              <el-button
                @click="handleCheck(row,'appList/details/editor')"
                type="text"
                size="small"
              >修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <common-page :page-data="pageData" @change="onChangePage">
      <button
        class="button"
        slot="right-aside"
        @click="handleCheck({},'/home/appList/details/create')"
      >新建项目</button>
    </common-page>
  </div>
</template>

<script>
import { table, queryPage, dataListHeight } from '@/mixins'
import { mapGetters } from 'vuex'
import store from './selects'

export default {
  mixins: [dataListHeight, queryPage, table],
  data() {
    return {
      query: {
        ECreateTime: '',
        EValidTime: '',
        SCreateTime: '',
        SValidTime: '',
        invokeType: '',
        maxRemanentCount: '',
        minRemanentCount: '',
        provideCompany: '',
        state: '',
        usePerm: '',
      },
      // 下拉 接口状态
      stateList: store.stateList,
      // 下拉 查询状态
      selectStateList: store.selectStateList,
      invokeTypeList: store.invokeTypeList,
      usePermList: store.usePermList,
    }
  },
  computed: {
    ...mapGetters(['selects']),
  },

  methods: {
    /**
     * @desc 跳转
     * @param {行数据,跳转地址}
     */
    handleCheck(row, to) {
      this.$router.push({
        path: `${to}`,
        query: { _i: row.id, apiCode: row.apiCode },
      })
    },

    // 请求列表接口
    getListData() {
      const {
        pageData: { currentPage, pageSize },
        query,
        $store: { dispatch },
      } = this

      return dispatch('T9/APIList/getList', {
        ...query,
        currentPage,
        pageSize,
      }).then((res) => {
        let { list, total, pageNum } = res
        this.listData = list
        this.pageData.currentPage = pageNum
        this.pageData.total = total
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/css/Common/tableList.scss';
</style>
